export default __webpack_public_path__ + "media/images/footer/diners-39b809ffadc9a5dc49dad6e6674f5dd7.svg";